import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "contact-info" }
const _hoisted_3 = { class: "qr-section" }
const _hoisted_4 = { class: "qr-item" }
const _hoisted_5 = { class: "qr-info" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "qr-item" }
const _hoisted_8 = { class: "qr-info" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "qr-item" }
const _hoisted_11 = { class: "qr-info" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "qr-item" }
const _hoisted_14 = { class: "qr-info" }
const _hoisted_15 = ["src"]

import { onUnmounted, watch } from 'vue'
import serviceWechatQr from '@/assets/images/service-wechat.jpg'
import bryanWechatQr from '@/assets/images/bryan-wechat.jpg'
import liuWechatQr from '@/assets/images/liu-wechat.jpg'
import tiphaineWechatQr from '@/assets/images/tiphaine-wechat.jpg'

interface Props {
  isVisible: boolean
}

interface Emits {
  (e: 'update:isVisible', value: boolean): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactModal',
  props: {
    isVisible: { type: Boolean }
  },
  emits: ["update:isVisible"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const closeModal = () => {
  emit('update:isVisible', false)
}

const initialBodyOverflow = document.body.style.overflow

watch(
  () => props.isVisible,
  (isVisible) => {
    document.body.style.overflow = isVisible ? 'hidden' : initialBodyOverflow
  },
  { immediate: true }
)

onUnmounted(() => {
  document.body.style.overflow = initialBodyOverflow
})

return (_ctx: any,_cache: any) => {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal-overlay",
        onClick: closeModal
      }, [
        _createElementVNode("div", {
          class: "modal",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", { class: "modal-header" }, [
            _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "modal-title" }, "Contactez-nous", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "modal-close",
              onClick: closeModal
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("span", null, "×", -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "contact-section" }, [
                _createElementVNode("h4", null, "Service client"),
                _createElementVNode("p", null, "Pour toutes les questions concernant les commandes et les expéditions"),
                _createElementVNode("div", { class: "contact-details" }, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, "Téléphone :"),
                    _createTextVNode(" 01 53 27 91 08")
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, "Email :"),
                    _createTextVNode(" service@efashion-paris.com")
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[3] || (_cache[3] = _createElementVNode("h5", null, "Service client", -1)),
                    _createElementVNode("img", {
                      src: _unref(serviceWechatQr),
                      alt: "QR code WeChat Service client",
                      class: "w-full max-w-[220px] mx-auto rounded"
                    }, null, 8, _hoisted_6)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("h5", null, "Bryan - CEO", -1)),
                    _createElementVNode("img", {
                      src: _unref(bryanWechatQr),
                      alt: "QR code WeChat Bryan Chen",
                      class: "w-full max-w-[220px] mx-auto rounded"
                    }, null, 8, _hoisted_9)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[5] || (_cache[5] = _createElementVNode("h5", null, "Liu - Relation grossiste", -1)),
                    _createElementVNode("img", {
                      src: _unref(liuWechatQr),
                      alt: "QR code WeChat Liu",
                      class: "w-full max-w-[220px] mx-auto rounded"
                    }, null, 8, _hoisted_12)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[6] || (_cache[6] = _createElementVNode("h5", null, "Tiphaine - Studio photo", -1)),
                    _createElementVNode("img", {
                      src: _unref(tiphaineWechatQr),
                      alt: "QR code WeChat Tiphaine",
                      class: "w-full max-w-[220px] mx-auto rounded"
                    }, null, 8, _hoisted_15)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "modal-btn btn-danger",
              onClick: closeModal
            }, " Fermer ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})